





















































































import { defineComponent, PropType, computed, ref, onUpdated, onMounted, watch } from '@vue/composition-api';
import NavigationItem from '@/components/NavigationItem.vue';
import ChannelTreeNavMenu from '@/components/ChannelTreeNavMenu.vue';
import UiChannelTree from '@/data/UiChannelTree';
import useMainLayout from '@/composables/useMainLayout';
import ChannelMenuButton from '@/components/ChannelMenuButton.vue';
import { LayoutType } from '@/data/layout/MainLayoutInfo';

// @ts-ignore
export default defineComponent({
  components: {
    NavigationItem,
    ChannelTreeNavMenu,
    ChannelMenuButton
  },
  props: {    
    uiChannelTree: {
      type: Object as PropType<UiChannelTree>,
      required: true
    },
    uiSubChannelTree: {
      type: Object as PropType<UiChannelTree>,
      required: false
    },
    menuIsOpen: {
      type: Boolean,
      required: true
    },
    searchIsOpen: {
      type: Boolean,
      default: false
    }
  },
  emits: {
    'nav-click': (/*id: number*/) => true,
    'select-click': (/*id: number*/) => true
  },
  setup(props, context) {

    const defaultOverFlowIndex = 100000;

    //const liElems = ref<Array<HTMLLIElement>>([]); // Vue3 version
    const ulElem = ref<HTMLUListElement|null>(null); // Vue3 version
    const navElem = ref<HTMLDivElement|null>(null);
    const hasChildren = computed(() => props.uiChannelTree.hasChildren());
    const { layoutType, fullWidth } = useMainLayout();
    const overFlowIndex = ref(defaultOverFlowIndex);
    //let isFirstUpdate = true;

    const showMenuButton = computed(() => {
      
      if(props.searchIsOpen && layoutType.value === LayoutType.SMALL) {
        return false;
      }

      return layoutType.value === LayoutType.SMALL || overFlowIndex.value != defaultOverFlowIndex;
    });

    const isSmallLayout = computed(() => {
      return layoutType.value === LayoutType.SMALL;
    });

    const isAncestor = (treeId: number) => {
      if(!props.uiSubChannelTree) return false;
      return props.uiSubChannelTree.isAncestor(treeId);
    };


    const showSubMenu = (ancestorTreeId: number) => {
      return !isSmallLayout.value && !props.menuIsOpen && props.uiSubChannelTree && (
        props.uiSubChannelTree.id === ancestorTreeId ||
        props.uiSubChannelTree.parentId === ancestorTreeId ||
        isAncestor(ancestorTreeId));
    };

    const getOverflowIndex = (): number => {
      
      if(!context.refs.ulElem) return defaultOverFlowIndex;

      //const ulElem: HTMLUListElement = context.refs.ulElem as HTMLUListElement;
      const liElems: Array<HTMLLIElement> = context.refs.liElems as Array<HTMLLIElement>;
      
      if(!liElems || liElems.length === 0) return 0;//defaultOverFlowIndex;

      //const w = ulElem.offsetWidth;
      const w = ulElem?.value?.clientWidth;
      if(!w) return 0;
      for(let i = 0; i < liElems.length; ++i) {
        const liElem = liElems[i];
        
        if(liElem.offsetWidth === 0 || liElem.offsetLeft + liElem.clientWidth + 120 > w) {
 
          return i;
        }
      }
                
      return defaultOverFlowIndex;
    };

    const getTree = computed(() => {
      return props.uiSubChannelTree ? props.uiSubChannelTree : props.uiChannelTree;
    });

    watch(
      () => fullWidth.value,
      () => {
        overFlowIndex.value = getOverflowIndex();
      }
    );
    onUpdated(() => {
      //if(isFirstUpdate) {
        overFlowIndex.value = getOverflowIndex();
      //  isFirstUpdate = false;
      //}
    });

    onMounted(() => {
      overFlowIndex.value = getOverflowIndex();
    });

    return {
      hasChildren,
      showSubMenu,
      //liElems, for VUE 3
      layoutType,
      overFlowIndex,
      showMenuButton,
      isSmallLayout,
      getTree,
      navElem,
      ulElem
    }
  }
});


